import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { ModuleComponent } from "../module.component";
import { GuideService } from "../../services/guide.service";
import { ScrollToService } from "ng2-scroll-to-el";
import { IdentityService } from "../../../services/identity.service";
import { ToastrService } from "ngx-toastr";

@Component({
  templateUrl: "./2A.component.html",
  styleUrls: ["../component.css"]
})
export class _2AComponent extends ModuleComponent {

  A12: string = ` `;
  A32: string = `Some examples include your resume, images of projects you have completed, samples of your writing or PowerPoint skills, links to websites you designed, or photos of cars you repaired.`;

  A22: string = ` `;

  constructor(router: Router, guideService: GuideService, modalService: BsModalService, scrollService: ScrollToService, identitySrv: IdentityService, toastr: ToastrService) {
    super(router, scrollService, guideService, modalService, identitySrv, toastr);

    this.titles.push({
      "activityId": "A11",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> about the things you need to begin a job search.`
    });
    this.titles.push({
      "activityId": "A12",
      "html": `<i class="fas fa-sticky-note"></i><strong>Identify</strong> Use the Notes tool to enter information about your previous employment, education, licenses or credentials, references, and recommendations.`
    });
    this.titles.push({
      "activityId": "A13",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response, update your career plan step called "Get Started: Learn how to prepare to find a job."`
    });

    this.titles.push({
      "activityId": "A21",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> why everyone needs a resume.`
    });
    this.titles.push({
      "activityId": "A22",
      "html": `<i class="fas fa-sticky-note"></i><strong>Identify</strong> Use the Notes tool to enter your Keywords and Action Words.`
    });
    this.titles.push({
      "activityId": "A23",
      "html": `<i class="fab fa-youtube"></i> <strong>Review</strong> how to use the resume builder tool available on Illinois workNet.`
    });
    this.titles.push({
      "activityId": "A24",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response - update the career plan dates on "Prepare your resume." In the notes portion, include your keywords and the type of resume that is best for you.`
    });



    this.titles.push({
      "activityId": "A31",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> what is a portfolio`
    });
    this.titles.push({
      "activityId": "A32",
      "html": `<i class="fas fa-sticky-note"></i> <strong>Identify</strong> what items you could include in a portfolio`
    });
    this.titles.push({
      "activityId": "A33",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the activity response: Update your career plan dates for "Organize your information"`
    });


    this.titles.push({
      "activityId": "A41",
      "html": `<i class="fas fa-file-import"></i> <strong>Identify</strong> the items to make your job search plan productive.`
    });
    this.titles.push({
      "activityId": "A42",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Create</strong> goals to complete your job search plan. i.e. get dates for work experience, or request a recommendation to add to portfolio`
    });

    this.titles.push({
      "activityId": "A51",
      "html": `<i class="fas fa-file-import"></i> Test your knowledge of what you learned. These questions will be on the post-assessment test.`
    });



    this.group = 1;
    this.alpha = "A";

    this.activeMod = { group: 1, alpha: "A", number: 1 };
  }

  ngOnInit() {    
  }

  ngAfterViewInit() {

    this.loadGuide();
  }
}
